import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "ui/components/card";
import ActivityList from "./components/list";
import ActivityEditor from "./components/editor";
import { useBillable } from "@/modules/work/billables/context";
import { useQuery } from "@tanstack/react-query";
import { billableKeys } from "@/modules/work/billables/queries";
import { createBillableActivity, fetchBillableActivities } from "./api";

import { Separator } from "ui/components/separator";
import { invalidateAllQueries } from "utils/utils";
import { PermissionGate } from "permissions/components/gate";
import Meme from "components/meme";

export default function BillableActivity() {
  const { billableId } = useBillable();

  const {
    data: activities = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: billableKeys.activities(billableId),
    queryFn: () => fetchBillableActivities(billableId),
    enabled: !!billableId,
  });

  async function handleSubmit({ message, attachment }) {
    await createBillableActivity({
      item: {
        collection: "billables",
        item: billableId,
        comment: message,
        attachment,
      },
    });
    invalidateAllQueries();
  }

  if (isLoading) return <div className="p-6">Loading activity...</div>;
  if (isError)
    return (
      <div className="p-6 text-red-600">
        {error?.message || "Error loading activity"}
      </div>
    );

  return (
    <div className="flex-1 p-4 sm:p-6">
      <Card className="shadow-none">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">Activity</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <PermissionGate rule="create:*" collection="directus_comments">
            <ActivityEditor onSubmit={handleSubmit} />
            <Separator />
          </PermissionGate>
          <ActivityList activities={activities} />
        </CardContent>
      </Card>
    </div>
  );
}
